import { PropsWithChildren } from 'lib-shared-types-utils';

import { useDashboardViewInit } from './utils/useDashboardViewInit';

export const DashboardView = ({
  children,
}: PropsWithChildren): JSX.Element | null => {
  const { isInitialized } = useDashboardViewInit();

  if (!isInitialized) {
    return null;
  }

  return <>{children}</>;
};
